export default __webpack_public_path__ + "static/media/logo.83931724.png";